import { RouteObject } from "react-router-dom";
import {
  SIGNING_DOCUMENTS_PATH,
  SigningDocumentsPage,
} from "@/modules/signing/pages/signing-documents";
import {
  MY_DOCUMENTS_FOR_SIGNING_PATH,
  MyDocumentsForSigningPage,
} from "@/modules/signing/pages/my-documents-for-signing";
import {
  SIGN_DOCUMENT_TYPES_LIST_PATH,
  SignDocumentTypesListPage,
} from "@/modules/signing/pages/sign-document-types-list-page";
import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import {
  FileProtectOutlined,
  FileSyncOutlined,
  HddOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import { SIGN } from "@/shared/modules/constants/modules-id";
import { AllTokens } from "gql/graphql";

export const signingRoutes: RouteObject[] = [
  {
    path: SIGNING_DOCUMENTS_PATH,
    element: <SigningDocumentsPage />,
  },
  {
    path: MY_DOCUMENTS_FOR_SIGNING_PATH,
    element: <MyDocumentsForSigningPage />,
  },
  {
    path: SIGN_DOCUMENT_TYPES_LIST_PATH,
    element: <SignDocumentTypesListPage />,
  },
];

export const signingMenuItems: NavigationItem = {
  label: "signing documents",
  icon: <ReconciliationOutlined />,
  children: [
    {
      label: "document registry",
      to: SIGNING_DOCUMENTS_PATH,
      icon: <HddOutlined />,
      requiredModule: SIGN,
      requiredAtLeastOnePermission: [AllTokens.DocumentsSigningRegistry],
    },
    {
      label: "my documents for signing",
      to: MY_DOCUMENTS_FOR_SIGNING_PATH,
      icon: <FileSyncOutlined />,
      requiredModule: SIGN,
    },
    {
      label: "sign document types",
      to: SIGN_DOCUMENT_TYPES_LIST_PATH,
      icon: <FileProtectOutlined />,
      requiredModule: SIGN,
      requiredAtLeastOnePermission: [AllTokens.DocumentsSigningTypes],
    },
  ],
};
